<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="Author-tp"><a id="_idTextAnchor002"></a>R. Allen Shoaf</p>
<p class="Title-tp ParaOverride-3">Language to Live In</p>
<div class="_idGenObjectLayout-1">
<div id="_idContainer000">
<img alt="" class="_idGenObjectAttribute-1" src="image/Logo-for-titlepages-new-bw.jpg"/>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781645367314_EPUB-2.vue?d94f4140